import { html } from "../../render";
import { cn, spreadAttrs } from "../../utils";
import { LpButton } from "../button";
import { LpSectionHeader } from "../section-header";
const editPageManagedAttrs = ["data-lp-component", "class"];
export function LpEditPage({ children, className, attributes }) {
    return html `
        <div
            data-lp-component="EditPage"
            class="${cn("edit-page", className, attributes?.class)}"
            ${spreadAttrs(attributes, { omit: editPageManagedAttrs })}
        >
            ${children}
        </div>
    `;
}
export function LpEditCard({ title, description, header, actions, children, className, bodyClassName, attributes, }) {
    const hasHeader = header || title || description || actions;
    return html `
        <section
            data-lp-component="EditCard"
            class="${cn("edit-card", className, attributes?.class)}"
            ${spreadAttrs(attributes, { omit: editPageManagedAttrs })}
        >
            ${hasHeader
        ? html `
                    <div class="edit-card__header">
                        ${header || LpSectionHeader({ title: title || "", description })}
                        ${actions ? html `<div class="edit-card__actions">${actions}</div>` : ""}
                    </div>
                `
        : ""}
            ${children
        ? bodyClassName
            ? html `<div class="${cn("edit-card__body", bodyClassName)}">${children}</div>`
            : children
        : ""}
        </section>
    `;
}
export function LpEditGrid({ children, className, attributes }) {
    return html `
        <div
            data-lp-component="EditGrid"
            class="${cn("edit-grid", className, attributes?.class)}"
            ${spreadAttrs(attributes, { omit: editPageManagedAttrs })}
        >
            ${children}
        </div>
    `;
}
export function LpEditSectionTitle({ title, className, attributes, }) {
    return html `
        <div
            data-lp-component="EditSectionTitle"
            class="${cn("edit-section-title edit-span", className, attributes?.class)}"
            ${spreadAttrs(attributes, { omit: editPageManagedAttrs })}
        >
            <span>${title}</span>
        </div>
    `;
}
export function LpEditTabs({ ariaLabel, itemsBinding = "sections", clickBinding = "$parent.onClickSection", activeExpression = "$parent.activeSection() === id", completeExpression = "$parent.sectionCompletion()[id]", className, attributes, }) {
    return html `
        <nav
            data-lp-component="EditTabs"
            class="${cn("edit-nav edit-nav--tabs", className, attributes?.class)}"
            aria-label="${ariaLabel}"
            ${spreadAttrs(attributes, { omit: editPageManagedAttrs })}
        >
            <!-- ko foreach: ${itemsBinding} -->
            <button class="edit-nav__item" type="button" data-bind="click: ${clickBinding}, css: { 'is-active': ${activeExpression}, 'is-complete': ${completeExpression} }">
                <!-- ko if: icon -->
                <i data-lp-component="Icon" data-icon-weight="regular" aria-hidden="true" data-bind="attr: { class: 'edit-nav__icon lp-icon ph ph-' + icon }"></i>
                <!-- /ko -->
                <span class="edit-nav__label" data-bind="text: label"></span>
            </button>
            <!-- /ko -->
        </nav>
    `;
}
export function LpEditSteps({ visibleBinding = "!id()", previousBinding = "visible: !isFirstSection(), click: onClickPrevious", nextBinding = "visible: !isLastSection(), click: onClickNext", previousVisibleBinding, nextVisibleBinding, className, attributes, } = {}) {
    return html `
        <div
            data-lp-component="EditSteps"
            class="${cn("contract-edit-steps", className, attributes?.class)}"
            data-bind="visible: ${visibleBinding}"
            ${spreadAttrs(attributes, { omit: editPageManagedAttrs })}
        >
            ${LpButton({
        label: 'Previous',
        variant: 'secondary',
        attributes: {
            'data-bind': previousVisibleBinding
                ? `visible: ${previousVisibleBinding}, click: onClickPrevious`
                : previousBinding,
        },
    })}
            ${LpButton({
        label: 'Next',
        variant: 'primary',
        attributes: {
            'data-bind': nextVisibleBinding
                ? `visible: ${nextVisibleBinding}, click: onClickNext`
                : nextBinding,
        },
    })}
        </div>
    `;
}
